import React from "react"
import "./footer.scss"

const Footer = () => {

  return (
    <footer>
      <div className="footer-grid">
        <div className="left-column">
        </div>
        <div className="rigth-column">
          <div className="top-button">
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
